import API from "../../apiConfig";

export const generateOTP = async (username, isWoSeller) => {
  const response = await API.post("user/seller/generateOtp", { username, isWoSeller }, { withCredentials: false });
  return response;
};

export const signUp = async (data) => {
  const response = await API.post("user/v1/seller/verifyotp", data, { withCredentials: false });
  return response;
};